import { onExternalCalendarActivity } from "common/signalR";
import ActivityPanel from "components/ActivityPanel/ActivityPanel";
import React from "react";
import { ExternalCalendarActivityCard } from "./ExternalCalendarActivityCard";
import { useCurrentUser } from "common/SessionContext";

interface Props {
  externalCalendarId: number
  config: server.dto.ActivityPanelConfig
}

export const ExternalCalendarActivityPanel = (props: Props) => {
  const currentUser = useCurrentUser();
  return <ActivityPanel<server.dto.ExternalCalendarActivity>
    activityKey="externalCalendar"
    itemId={props.externalCalendarId}
    config={props.config}
    fetchActivities={(page, perPage) => window.CoreApi.ExternalCalendar.ListActivity({ itemId: props.externalCalendarId, page, perPage })}
    renderActivity={(activity => <ExternalCalendarActivityCard
      key={activity.activityId}
      activity={activity}
    />)}
    onActivityRegisterFn={onExternalCalendarActivity}
    onActivity={(activity) => {
      const iAmActor = (activity.actor?.userId === currentUser.userId);

      return { refreshActivities: iAmActor };
    }}
  />
}
